export default __webpack_public_path__ + "static/media/img-slider-lh-job-sale-4.a3d88624.png";